import { usePresenceViewers } from "@hooks/presence/usePresenceViewers";
import { useIsTaskOpen } from "@components/tasks/tasks.context";
import { useTaskViewersTarget } from "./useTaskViewersTarget";

/**
 * Who is viewing a task of the list. Empty while a task body is open, which
 * shows its own viewers.
 */
export const useTaskRowViewerIds = ({
    taskId,
    workspaceId,
}: {
    taskId: string;
    workspaceId: string;
}) => {
    const isTaskOpen = useIsTaskOpen();
    const target = useTaskViewersTarget({ taskId, workspaceId });
    return usePresenceViewers(isTaskOpen ? null : target);
};
